import { createContext } from 'react';

import type {
  Customer,
  FeatureFlagChangeListener,
  FeatureFlagOverrides,
  FeatureFlags,
} from './types';

// ─────────────────────────────────────────────────────────────────────────────

export const LaunchDarklyContext = createContext<
  LaunchDarklyContextType | undefined
>(undefined);

// ─── Types ───────────────────────────────────────────────────────────────────

export type LaunchDarklyContextType = Readonly<{
  defaults: FeatureFlags;
  overrides: FeatureFlagOverrides;
  initialFeatureFlags: FeatureFlags | undefined;
  isReady: boolean;

  // ─────────────────────────────────────────────

  init: (customer?: Customer) => Promise<void>;
  identifyCustomer: (customer: Customer) => Promise<unknown> | undefined;
  resetCustomer: () => Promise<void>;
  registerFeatureFlagListener: FeatureFlagChangeListener;
  unregisterFeatureFlagListener: FeatureFlagChangeListener;
  close: () => Promise<void>;
}>;
